import { REGEXP } from '@/constants/regexp';
import { COLLOCATION_STATUS_TEXTS, COLLOCATION_STATUS_VALUES } from '@/business-components/CollocationStatus/constant';

// 筛选项模板
export const FILTER_TEMPLATE = {
  numArray: {
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
    rules: [
      {
        pattern: REGEXP.numArray,
        message: '请输入数字类型，多值使用英文逗号分隔，形如：100或100,101,102',
      },
    ],
  },
};

// 账户类型
export const BUYING_TYPE_LIST = [
  { label: '全部类型', value: '' },
  { label: '竞价&合约', value: 'BUYINGTYPE_AUCTION', tip: '支持投放腾讯全流量竞价投放，微信搜一搜、微信视频号合约投放' },
  { label: '合约', value: 'BUYINGTYPE_CONTRACT', tip: '支持投放腾讯新闻、腾讯视频、手机QQ等平台内容与媒体合约投放' },
];

// 授权开户状态
export const AUTHORIZE_TYPE_LIST = [
  { label: '预授权', value: '0' },
  { label: '已取消', value: '1' },
  { label: '已授权', value: '2' },
  { label: '已拒绝', value: '3' },
  { label: '已过期', value: '4' },
];

// 账户类型
export const BUYING_TYPE_FAST_LIST = [
  { label: '全部类型', value: '' },
  { label: '竞价&合约', value: 1, tip: '支持投放腾讯全流量竞价投放，微信搜一搜、微信视频号合约投放' },
  { label: '合约', value: 2, tip: '支持投放腾讯新闻、腾讯视频、手机QQ等平台内容与媒体合约投放' },
  { label: 'CPS', value: 3 },
];

// 账户状态
export const CUSTOMER_STATUS_LIST = [
  { label: '全部状态', value: '' },
  { label: '有效', value: 'CUSTOMERSTATUS_NORMAL' },
  { label: '审核不通过', value: 'CUSTOMERSTATUS_DENIED' },
  { label: '待审核', value: 'CUSTOMERSTATUS_PENDING' },
  { label: '封停', value: 'CUSTOMERSTATUS_FROZEN' },
  { label: '冻结', value: 'CUSTOMERSTATUS_FREEZE' },
  { label: '联系人待验证', value: 'CUSTOMERSTATUS_MATERIAL_PREPARED', tip: '请联系账户联系人进行开户验证，验证二维码可在“更多”中获取' },
  { label: '预审核', value: 'CUSTOMERSTATUS_PRE_AUDIT' },
  { label: '预审核不通过', value: 'CUSTOMERSTATUS_PRE_AUDIT_REJECT' },
];

// 账户是否启用
export const FORBIDDEN_CREATE_AD_STATUS = [
  { label: '启用中', value: 0 },
  { label: '未启用', value: 1 },
];
export const MERGED_STATUS_LIST = [
  { label: '全部状态', value: '' },
  { label: '有效', value: 1 },
  { label: '审核不通过', value: 3 },
  { label: '待审核', value: 2 },
  { label: '封停', value: 4 },
  { label: '冻结', value: 21 },
];
export const IMPRESSION_AFFACTION_LEVEL = [
  { label: '全部', value: '' },
  { label: '很低', value: 4 },
  { label: '低', value: 3 },
  { label: '中', value: 2 },
  { label: '高', value: 1 },
];

// 自动衍生创意
export const DERIVE_STATUS_LIST = [
  { label: '全部状态', value: '' },
  { label: '已开启', value: 1 },
  { label: '已关闭', value: 2 },
];

// 托管状态
export const COLLOCATION_STATUS_LIST = [
  { label: '全部状态', value: '' },
  { label: COLLOCATION_STATUS_TEXTS.BOTH, value: COLLOCATION_STATUS_VALUES.BOTH },
  { label: COLLOCATION_STATUS_TEXTS.NONE, value: COLLOCATION_STATUS_VALUES.NONE },
  { label: COLLOCATION_STATUS_TEXTS.SYSTEM, value: COLLOCATION_STATUS_VALUES.SYSTEM },
  { label: COLLOCATION_STATUS_TEXTS.CUSTOME, value: COLLOCATION_STATUS_VALUES.CUSTOME },
];

// 余额状态
export const BALANCE_STATUS_LIST = [
  { label: '全部状态', value: '' },
  { label: '不足', value: 2 },
  { label: '偏低', value: 3 },
  { label: '充足', value: 5 },
];

// 运营方式
export const OPERATION_LABEL_LIST = [
  { label: '全部', value: '' },
  { label: '自运营', value: '自运营' },
  { label: '代运营', value: '代运营' },
  { label: '渠道运营', value: '渠道运营' },
];

// 运营状态
export const OPERATION_RIGHT_STATUS_LIST = [
  { label: '全部', value: '' },
  { label: '未设置', value: 0 },
  // { label: '未灰度', value: -1 },
  { label: '客户自运营', value: 1 },
  { label: '代理商代运营', value: 2 },
];

// 广告主付款类型
export const PAY_TYPE_LIST = [
  { label: '全部', value: '' },
  { label: '垫付', value: '垫付' },
  { label: '预付', value: '预付' },
];

// 自动转账
export const AUTO_TRANSFER_VALID_LIST = [
  { label: '全部类型', value: '' },
  { label: '开通', value: '1' },
  { label: '关闭', value: '0' },
];

// 收藏
export const IS_COLLECT_ADVERTISER_LIST = [
  { label: '全部', value: '' },
  { label: '仅收藏账户', value: 'YES' },
];

// 任务来源
export const TASK_SOURCE = [
  { label: '全部', value: '' },
  { label: '公有库', value: 0 },
  { label: '私有库', value: 1 },
];

// 是否激励任务
export const IS_INTEREST_TASK = [
  { label: '全部', value: '' },
  { label: '否', value: 0 },
  { label: '是', value: 1 },
];

// 预计消耗
export const PREDICT_REMAIN_DAYS_LIST = [
  { label: '>7', value: 10000 },
  { label: '7', value: 7 },
  { label: '6', value: 6 },
  { label: '5', value: 5 },
  { label: '4', value: 4 },
  { label: '3', value: 3 },
  { label: '2', value: 2 },
  { label: '1', value: 1 },
  { label: '<1', value: 0 },
];

export const OPERATION_OBJECT_TYPE_LIST = [
  { label: '客户账户', value: 1 },
  { label: '服务商账户', value: 2 },
  { label: '员工', value: 3 },
  { label: '主体账户', value: 4 },
  // { label: "组织", value: 5 },
  { label: '线索', value: 6 },
  { label: '定时报表', value: 7 },
];

export const OPERATION_TYPE_LIST = [
  { label: '全部', value: '' },
  { label: '新增', value: 1 },
  { label: '修改', value: 2 },
  { label: '删除', value: 3 },
];

// 在职状态
export const EMPLOYEE_STATUS_LIST = [
  { label: '在职', value: '0' },
  { label: '离职', value: '1' },
];

// 员工类型
export const EMPLOYEE_TYPE_LIST = [
  { label: '内部员工', value: 1 },
  { label: '外部员工', value: 2 },
  { label: '子帐号员工', value: 3 },
];

// 财务-财务记录-MP(广告主)
export const FINANCE_OPERATION_MP_AD_LIST = [
  { label: '转账', value: 'TRANSFER' },
  { label: '回划', value: 'RECOVER' },
  { label: '回划申请', value: 'RECOVER_APPLY' },
];

export const FINANCE_OPERATION_MP_AGENCY_LIST = [
  { label: '充值', value: 'RECHARGE' },
  { label: '退款', value: 'REFUND' },
  { label: '转账', value: 'TRANSFER' },
];

// 财务-财务记录-ADQ
export const FINANCERECORDTYPES_LIST = [
  { label: '资金账户记录', value: [1] },
];

// 财务-财务记录-ADQ操作类型
export const FINANCE_OPERATION_TYPE_LIST = [
  { label: '扣费', value: 1 },
  { label: '充值', value: 2 },
  { label: '转账', value: 3 },
  { label: '账户调整', value: 5 },
];

export const FINANCE_OPERATION_TYPE_SHARED_WALLET_LIST = [
  { label: '扣费', value: 1 },
  { label: '转账', value: 3 },
];

export const FINANCE_INOUT_TYPES = [
  { label: '全部类型', value: '' },
  { label: '收入', value: [1] },
  { label: '支出', value: [2] },
];

export const BOOL_LIST = [
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];

export const BOOL_LIST_ALL = [
  { label: '全部', value: '' },
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];

// 任务反馈
export const FEEDBACK_TYPE_LIST = [
  {
    value: 102,
    desc: '任务执行反馈以及建议和意见',
  },
  {
    value: 100,
    desc: '已经执行，未完成原因（执行率>0）',
    options: [
      {
        value: 201,
        desc: '客户原因（客户明确拒绝）',
      },
      {
        value: 202,
        desc: '服务商自身原因（服务商判断无法完成）',
      },
    ],
  },
  {
    value: 101,
    desc: '未执行，未完成原因（执行率=0）',
    options: [
      {
        value: 203,
        desc: '客户原因（客户明确拒绝）',
      },
      {
        value: 204,
        desc: '服务商自身原因（服务商判断无法完成）',
      },
    ],
  },
  {
    value: 199,
    desc: '其他导致未完成（审核、自运营、产品等原因）',
    options: [
      {
        value: 205,
        desc: '产品/审核/系统相关',
      },
      {
        value: 206,
        desc: '一二代相关',
      },
    ],
  },
];

export const INACTIVE_DAYS_LIST = [
  { label: '>=3天', value: 3 },
  { label: '>=7天', value: 7 },
  { label: '>=15天', value: 15 },
  { label: '>=1个月', value: 30 },
  { label: '>=3个月', value: 90 },
  { label: '>=6个月', value: 180 },
  { label: '>=1年', value: 365 },
];

export const MERGE_FUND_TYPE_LIST = [
  { label: '全部来源', value: 0 },
  { label: '广告充值金', value: 1001 },
  { label: '专项充值金', value: 1002 },
];

// 附近推账号
export const IS_LOCAL_BUSINESS_LIST = [
  { label: '全部', value: '' },
  { label: '是', value: 1 },
  { label: '否', value: 0 },
];

export const K_FRAME_LIST_NO_ALL = [
  { label: 'k1_frame', value: 'k1_frame' },
  { label: 'k2_frame', value: 'k2_frame' },
  { label: 'k3_frame', value: 'k3_frame' },
  { label: 'k4_frame', value: 'k4_frame' },
  { label: 'k5_frame', value: 'k5_frame' },
  { label: '内部客户', value: '内部客户' },
  { label: '海外客户', value: '海外客户' },
  { label: '封闭_区域医药', value: '封闭_区域医药' },
  { label: '封闭_区域运营商', value: '封闭_区域运营商' },
  { label: '封闭_区域房产', value: '封闭_区域房产' },
  { label: '封闭_区域汽车', value: '封闭_区域汽车' },
  { label: '封闭_区域互动', value: '封闭_区域互动' },
];

export const K_FRAME_LIST = [
  { label: '全部', value: '' },
  ...K_FRAME_LIST_NO_ALL,
];

// 任务中使用的签框范围
export const K_FRAME_LIST_IN_TASK = [
  { label: '全部', value: 'all' }, // '' 会导致无法选中，所以用 'all'
  { label: 'K1', value: 'k1_frame' },
  { label: 'K2', value: 'k2_frame' },
  { label: 'K3', value: 'k3_frame' },
  { label: 'K4', value: 'k4_frame' },
  { label: 'K5', value: 'k5_frame' },
  { label: '封闭-区域房产', value: '封闭-区域房产' },
  { label: '封闭-区域汽车', value: '封闭-区域汽车' },
  { label: '封闭-区域运营商', value: '封闭-区域运营商' },
];

export const COST_TYPE_LIST = [
  { label: '合约', value: 1 },
  { label: '竞价', value: 2 },
];

// 开票类型
export const PAID_TYPE_LIST = [
  { label: '预付 ', value: 1 },
  { label: '后付', value: 2 },
];
